const ns_group = {
	dialog_add: {
		autocomplete_debtor: {
			placeholder: "Select a debtor",
		},
		autocomplete_ns_group: {
			helper_text: "Select an Oxxa nameserver. If it does not exist, create it in Oxxa",
			placeholder: "Select an Oxxa nameserver group",
		},
		description: "Link a custom nameserver group to a debtor",
		has_dns_support: "This nameserver group supports DNS editing through the portal.",
		message_error: "Something went wrong while adding the nameserver group to the debtor!",
		message_success: "Nameserver group successfully added to debtor!",
		title: "Custom nameserver group",
	},
	dialog_del: {
		alert_info: "When removed, new domains will be registered with the default Tuxis nameservers",
		description: "Are you sure you want to delete <strong>{{ns_group}}</strong>?",
		message_error: "Something went wrong while deleting the nameserver group to the debtor!",
		message_success:
			"Nameserver group <strong>{{ns_group}}</strong> successfully removed for debtor <strong>{{debtor_code}}</strong>!",
		title: "Delete nameserver group",
	},
};

export default ns_group;
